import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import styles from "./ActionsRenderer.module.css";
import { saveTemplateFieldConfigDetails } from "../../RulesPage.service";
import { TemplateRuleRow } from "../RulesModal/RulesModal.types";

interface ActionRendererProps {
  data: TemplateRuleRow;
  onEdit: (data: TemplateRuleRow) => void;
  onDelete: () => void;
}

const ActionRenderer: React.FC<ActionRendererProps> = ({
  data,
  onEdit,
  onDelete,
}) => {
  const handleDeleteClick = async () => {
    const success = await saveTemplateFieldConfigDetails([
      {
        ...data,
        RuleActive: "N",
      },
    ], true);

    if (success) {
      onDelete();
    }
  };

  return (
    <div>
      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip>Edit rule</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={`${styles.editActionButton} ${styles.actionButton}`}
            onClick={() => onEdit(data)}
          >
            <Icon.PencilSquare />
          </Button>
        </span>
      </OverlayTrigger>

      <OverlayTrigger
        placement="bottom"
        overlay={<Tooltip>Delete rule</Tooltip>}
      >
        <span className={styles.tooltipWrapper}>
          <Button
            className={`${styles.deleteActionButton} ${styles.actionButton}`}
            onClick={handleDeleteClick}
          >
            <Icon.Trash />
          </Button>
        </span>
      </OverlayTrigger>
    </div>
  );
};

export default ActionRenderer;
